import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext.tsx';

export enum GetSurveyTemplateCacheKey {
  SurveyTemplates = 'PAST_SURVEYS',
}

export const useGetSurveyTemplatesQuery = () => {
  const { fetchSurveyTemplates } = useServicesContext();
  return useQuery({
    queryKey: [GetSurveyTemplateCacheKey.SurveyTemplates],
    queryFn: () => fetchSurveyTemplates(),
  });
};
